import type { GroupColor } from 'state/quotes/dashboard/tiles/tiles.model';
import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

const lightThemePalette: string[] = [
  'mako',
  'puerto-rico',
  'cornflower-blue',
  'spicy-mix',
  'faded-jade',
  'heather',
  'azure',
  'victoria',
];

const darkThemePalette: string[] = [
  'plantation',
  'turquoise-blue',
  'dodger-blue',
  'copper-rust',
  'pacific-blue',
  'mercury',
  'manatee',
  'east-bay',
];

function getPalette(theme: SgBsTheme) {
  return theme === 'dark' ? darkThemePalette : lightThemePalette;
}

function getColorName(theme: SgBsTheme, color: GroupColor) {
  const palette = getPalette(theme);
  return palette[color];
}

export function mapColorToVariable(theme: SgBsTheme, color: GroupColor) {
  const colorName = getColorName(theme, color);
  return `var(--bs-${colorName})`;
}
